import { render, staticRenderFns } from "./ExpensesAndRevenues.vue?vue&type=template&id=75edc5f4&"
import script from "./ExpensesAndRevenues.vue?vue&type=script&lang=js&"
export * from "./ExpensesAndRevenues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports